/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  ButtonBase,
  Fade,
  SvgIcon,
  Typography
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import moment from 'moment-jalaali'
import { useEffect } from 'react'

import { ReactComponent as MyIconSvg } from '../../../../assets/images/Group.svg'
import { CounterWithLabel } from '../../../../components/CounterWithLabel'
import { DateRangePicker } from '../../../../components/DatePicker/DateRangePicker'
import {
  addDaysToDate,
  formatShortDateWithWeekDay
} from '../../../../helpers/date'
import { SITE_KEY } from '../../../../helpers/elements'
import { getTranslate, lang } from '../../../../localization'
import calculateRangeOfDays from '../../CalculateRangeOfDays'
import convertDate from '../../ConvertDate'
import SearchWidgetArrivalDate from '../../SearchWidgetArrivalDate'
import SearchWidgetDepartureDate from '../../SearchWidgetDepartureDate'
import SearchWidgetGuests from '../../SearchWidgetGuests'
import SearchWidgetSearchInput from '../../SearchWidgetSearchInput'
import { SearchWidgetProps } from '../SearchWidgetProps'
import useStyles from '../styles/SearchWidget.styles'

const SearchWidgetDesktopInterface: React.FC<SearchWidgetProps> = ({
  selectRangeModalIsOpen,
  setSelectRangeModalIsOpen,
  selectNumberOfGuestsModalIsOpen,
  setSelectNumberOfGuestsModalIsOpen,
  dateObject,
  setdateObject,
  guestsNumber,
  setguestsNumber,
  datePickerRef,
  effectFunction,
  guestInfoRef,
  type,
  options,
  readMode,
  setreadMode,
  searchAvailabilityInput,
  setSearchAvailabilityInput,
  loadingForWBSData,
  bookingRedirect,
  setBookingRedirect,
  isFromBooking,
  noShowDistination,
  selectingStartDate,
  setSelectingStartDate
}) => {
  const classes = useStyles()

  useEffect(
    () => effectFunction(),
    [
      datePickerRef,
      selectRangeModalIsOpen,
      selectNumberOfGuestsModalIsOpen,
      guestInfoRef
    ]
  )
  const nowDate = moment().format('YYYY-MM-DD')
  const tomorrow = addDaysToDate(nowDate, 1)
  const range =
    dateObject && dateObject.gregorianStartDate && dateObject.gregorianEndDate
      ? calculateRangeOfDays(
          dateObject && dateObject.gregorianStartDate
            ? dateObject.gregorianStartDate
            : nowDate,

          dateObject && dateObject.gregorianEndDate
            ? dateObject.gregorianEndDate
            : tomorrow
        )
      : 1

  const selectedDestination = options.find((item) => {
    if (searchAvailabilityInput && searchAvailabilityInput.cityID) {
      return item.cityID === searchAvailabilityInput.cityID
    } else if (
      searchAvailabilityInput &&
      searchAvailabilityInput.propertyCode
    ) {
      return item.destinationCode === searchAvailabilityInput.propertyCode
    }
  })

  const handleSearch = () => {
    const siteKey = SITE_KEY
    let url = ''
    if (isFromBooking) {
      const initialReferer = localStorage.getItem('Referer')
      url = `${bookingRedirect}/${
        searchAvailabilityInput.cityID ? 'city' : 'hotel'
      }/?filter=${encodeURIComponent(
        JSON.stringify(searchAvailabilityInput)
      )}&site-key=${encodeURIComponent(
        siteKey || ''
      )}&initial-referer=${encodeURIComponent(initialReferer || '')}`
    } else {
      url = `${bookingRedirect}/${
        searchAvailabilityInput.cityID ? 'city' : 'hotel'
      }/?filter=${encodeURIComponent(
        JSON.stringify(searchAvailabilityInput)
      )}&site-key=${encodeURIComponent(siteKey || '')}`
    }

    window.location.href = url
  }

  const disabled = !(
    (searchAvailabilityInput.propertyCode ||
      !!searchAvailabilityInput.cityID) &&
    !!dateObject.gregorianEndDate
  )

  return readMode ? (
    <div className={classes.readMode}>
      <div className={classes.left}>
        <div className={classes.iconContainer}>
          <SearchIcon className={classes.icon} />
        </div>
        <div className={classes.nameContainer}>
          <Typography variant="h4" className={classes.title}>
            {selectedDestination?.destinationName}
          </Typography>
          <div className={classes.individual}>
            <SvgIcon
              component={MyIconSvg}
              fontSize="small"
              color="primary"
              className={classes.svg}
            />
            <Typography variant="h4" className={classes.smallTitle}>
              {`${searchAvailabilityInput.guestsAges.length} ${getTranslate(
                'Travelers'
              )}${getTranslate(',')} 1 ${getTranslate('Room')} ${getTranslate(
                'and'
              )} ${range} ${getTranslate('Nights')}`}
            </Typography>
          </div>
        </div>
      </div>
      <div className={classes.middle}>
        <div className={classes.date}>
          <Typography variant="h4" className={classes.title2}>
            {`${
              searchAvailabilityInput.arrival &&
              formatShortDateWithWeekDay(searchAvailabilityInput.arrival, lang)
            }`}
          </Typography>
        </div>
        <div className={classes.date}>
          <Typography variant="h4" className={classes.title2}>
            {`${
              searchAvailabilityInput.departure &&
              formatShortDateWithWeekDay(
                searchAvailabilityInput.departure,
                lang
              )
            }`}
          </Typography>
        </div>
      </div>
      <div className={classes.right}>
        <Button
          color="primary"
          variant="contained"
          className={classes.btn}
          onClick={() => setreadMode(false)}>
          <Typography variant="h4" className={classes.btnText2}>
            {getTranslate('Update ')}
          </Typography>
        </Button>
      </div>
    </div>
  ) : (
    <div
      ref={datePickerRef}
      className={[
        classes.searchMode,
        noShowDistination ? classes.searchModeWithoutDistination : ''
      ].join(' ')}>
      {!noShowDistination && (
        <>
          <SearchWidgetSearchInput
            options={options}
            searchAvailabilityInput={searchAvailabilityInput}
            setSearchAvailabilityInput={setSearchAvailabilityInput!}
            loadingForWBSData={loadingForWBSData}
            setBookingRedirect={setBookingRedirect}
          />
          <div className={classes.separator} />
        </>
      )}
      <div
        onClick={() => {
          setSelectRangeModalIsOpen(true)
          setSelectingStartDate(true)
        }}
        className={classes.arrivalContainer}>
        <SearchWidgetArrivalDate
          data={convertDate(
            dateObject && dateObject.gregorianStartDate
              ? dateObject.gregorianStartDate
              : nowDate
          )}
          selectingStartDate={selectingStartDate}
        />
        {selectRangeModalIsOpen && (
          <Fade in={selectRangeModalIsOpen} timeout={500}>
            <div
              className={classes.datePickerModal}
              onClick={(event) => {
                event.stopPropagation()
              }}>
              <div className={classes.nightContainer}>
                <Typography variant="h4" className={classes.red}>
                  {range}
                </Typography>
                <Typography
                  variant="h4"
                  className={classes.text}>{`${getTranslate(
                  'Nights'
                )}`}</Typography>
              </div>
              <DateRangePicker
                onChange={(date) => {
                  setdateObject(date)
                }}
                dateObject={dateObject}
                type={type}
                onDoneClicked={(event) => {
                  event.stopPropagation()
                  setSelectRangeModalIsOpen(false)
                }}
                selectingStart={selectingStartDate}
                setSelectingStart={setSelectingStartDate}
              />
            </div>
          </Fade>
        )}
      </div>
      <div
        className={classes.departureContainer}
        onClick={() => {
          setSelectRangeModalIsOpen(true)
          setSelectingStartDate(false)
        }}>
        <SearchWidgetDepartureDate
          data={convertDate(
            dateObject && dateObject.gregorianEndDate
              ? dateObject.gregorianEndDate
              : undefined
          )}
          selectingStartDate={selectingStartDate}
        />
      </div>
      <div className={classes.separator} />
      <div onClick={() => setSelectNumberOfGuestsModalIsOpen(true)}>
        <SearchWidgetGuests guestsNumber={guestsNumber} />
        {selectNumberOfGuestsModalIsOpen && (
          <Fade in={selectNumberOfGuestsModalIsOpen} timeout={500}>
            <div className={classes.guestModal} ref={guestInfoRef}>
              <CounterWithLabel
                label={getTranslate('Adults')}
                value={guestsNumber}
                setValue={setguestsNumber}
                max={5}
                min={1}
              />
            </div>
          </Fade>
        )}
      </div>
      <div className={classes.searchButtonContianer}>
        <ButtonBase className={classes.buttonBase} disabled={disabled}>
          <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            fullWidth
            className={classes.searchButton}
            onClick={() => {
              if (!isFromBooking) {
                setreadMode(!readMode)
              }
              handleSearch()
            }}
            endIcon={<SearchIcon className={classes.searchIcon} />}>
            <Typography className={classes.btnText}>
              {getTranslate('Search')}
            </Typography>
          </Button>
        </ButtonBase>
      </div>
    </div>
  )
}
export default SearchWidgetDesktopInterface
